import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spaces_user = _resolveComponent("spaces-user")!
  const _component_spaces_user_transition = _resolveComponent("spaces-user-transition")!

  return (_openBlock(), _createBlock(_component_spaces_user_transition, null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.spacesStore.filteredMyContacts, (contact) => {
        return (_openBlock(), _createBlock(_component_spaces_user, {
          key: contact.user.accountId,
          user: contact.user,
          userType: _ctx.NETWORK_CONTACT_TYPES.MANAGE
        }, null, 8, ["user", "userType"]))
      }), 128))
    ]),
    _: 1
  }))
}